export default [
  {
    slug: 'rkhospital',
    title: 'RKHospital App',
    category: 'Security',
    period: '2026',
    role: 'Infrastructure Engineer',
    summary:
      '의료 서비스 기반 시나리오 모의해킹',
    coverImage: 'posts/tech/rkhospital/thumb.jpg',
    stack: ['Nginx', 'Spring Boot', 'React', 'MySQL', 'Android Studio', 'Kotlin', 'AWS', 'Terraform', 'Burp Suite', 'Frida'],
    markdownPath: '/posts/tech/rkhospital/index.md'
  },
  {
    slug: 'safety-medical-center',
    title: 'Safety Medical Center',
    category: 'Security',
    period: '2025',
    role: 'PM',
    summary:
      '의료 데이터 유출 방지를 위한 웹 취약점 자동 진단 시스템 구축',
    coverImage: 'posts/tech/safety-medical-center/thumb.jpg',
    stack: ['Python', 'Flask', 'Streamlit', 'HTML', 'MySQL', 'AWS'],
    markdownPath: '/posts/tech/safety-medical-center/index.md'
  },
  {
    slug: 'tourist',
    title: 'Tourist Insights Analysis',
    category: 'Data Analysis & Visualization',
    period: '2025',
    role: 'LLM Engineer',
    summary:
      '방한 관광객 인사이트 분석과 범죄율의 상관관계 분석',
    coverImage: 'posts/tech/tourist/thumb.jpg',
    stack: ['Python', 'Flask', 'Streamlit', 'HTML', 'MySQL', 'AWS'],
    markdownPath: '/posts/tech/tourist/index.md'
  },
  {
    slug: 'saferoad-system',
    title: 'SafeRoad System',
    category: 'Development',
    period: '2025',
    role: 'PM',
    summary:
      '도로 장애물 실시간 탐지 및 관리 시스템',
    coverImage: 'posts/tech/saferoad-system/thumb.jpg',
    stack: ['Spring Boot', 'MySQL', 'Raspberry Pi', 'Python', 'YOLO'],
    markdownPath: '/posts/tech/saferoad-system/index.md'
  },
];
